import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as sendFeedbackFormCreateReduceObject } from './sendFeedback/sendFeedbackForm';
import sendFeedbackSaga from './sendFeedback/sagas/sendFeedbackSaga';

export default [
  // Forms
  ...createCombineMapItem(
    'sendFeedbackForm',
    sendFeedbackFormCreateReduceObject,
    [sendFeedbackSaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/feedback/reducers/static/forms/reducersMap.js